import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';

// eslint-disable-next-line import/prefer-default-export
export function removeUnchangedValues(newModel, oldModel) {
  if (!oldModel) {
    return newModel;
  }
  const sameKeys = [];
  Object.entries(newModel).forEach(([key, value]) => {
    if (isEqual(value, oldModel[key])) {
      sameKeys.push(key);
    }
  });
  return omit(newModel, sameKeys);
}
